<form class="c-form" [formGroup]="form">
  <fieldset>
    <legend class="is-title">Selecione o contrato</legend>
    <label for="contrato" class="c-form__label">
      Contrato - Nome cliente
      <app-select-auto-complete name="contrato" formControlName="contrato" [dados]="contratos.registros"
        [funcaoDeComparacao]="comparaContrato" [filtrar]="filtrarContratos" [exibir]="exibirContrato"
        [valor]="valorContrato"></app-select-auto-complete>
      <app-mensagem-erro-input *ngIf="form.get('contrato')?.invalid && form.get('contrato')?.touched">Contrato é
        obrigatório.</app-mensagem-erro-input>
    </label>
  </fieldset>
  <label for="site" class="c-form__label">
    Site - Endereço
    <app-select-auto-complete name="site" formControlName="site" [dados]="sites.registros"
      [funcaoDeComparacao]="comparaSite" [filtrar]="filtrarSites" [exibir]="exibirSite"
      [valor]="valorSite"></app-select-auto-complete>
    <app-mensagem-erro-input *ngIf="form.get('site')?.invalid && form.get('site')?.touched">Site é
      obrigatório.</app-mensagem-erro-input>
  </label>

  <app-modal-general [showOrHideButton]="false" [showOrHideMessage]="false" #modal>
    <img src="/assets/images/kmDoBrasil/aviso/AvisoImportante.jpg" />
  </app-modal-general>

  <ng-container *ngIf="form.value.codContrato && form.value.site">
    <fieldset class="c-form__fieldset">
      <legend class="is-title">Endereço</legend>
      <div class="address-filter">
        <label class="c-form__checkbox-label">
          <mat-checkbox class="u-margin-top-0_18rem" formControlName="preencherEndereco">
            <p class="c-form__checkbox-label__text">Manter endereço cadastrado: <span
                class="u-font-weight-600">{{form.get('site')?.value?.endereco}}</span></p>
          </mat-checkbox>
        </label>

        <input class="filter__submit-button" type="button" (click)="limparEndereco()" value="Limpar">
      </div>
      <label for="cep" class="c-form__label">
        Cep *
        <input class="c-form__input" name="cep" formControlName="cep" mask="00000-000" />
        <app-mensagem-erro-input *ngIf="form.get('cep')?.invalid && form.get('cep')?.touched">Cep é
          obrigatório.</app-mensagem-erro-input>
      </label>
      <div class="c-form__double-input-container">
        <label for="logradouro" class="c-form__label u-width-77_5-percent">
          Logradouro (Rua, Av, etc.) *
          <input class="c-form__input" name="logradouro" formControlName="logradouro" maxlength="60" />
          <app-mensagem-erro-input *ngIf="form.get('logradouro')?.invalid && form.get('logradouro')?.touched">Logradouro
            é
            obrigatório.</app-mensagem-erro-input>
        </label>
        <label for="numero" class="c-form__label u-width-20-percent">
          Número *
          <input class="c-form__input" name="numero" formControlName="numero" />
          <app-mensagem-erro-input *ngIf="form.get('numero')?.invalid && form.get('numero')?.touched">Número é
            obrigatório.</app-mensagem-erro-input>
        </label>
      </div>
      <div class="c-form__double-input-container">
        <label for="estado" class="c-form__label u-width-47_5-percent">
          Estado *
          <select class="c-form__input is-select" name="estado" formControlName="estado" maxlength="2">
            <option value="" selected>Selecionar</option>
            <option *ngFor="let estado of estados" value="{{estado.sigla}}">{{estado.nome}}</option>
          </select>
          <app-mensagem-erro-input *ngIf="form.get('estado')?.invalid && form.get('estado')?.touched">Estado é
            obrigatório.</app-mensagem-erro-input>
        </label>
        <label for="cidade" class="c-form__label u-width-47_5-percent">
          Cidade *
          <select class="c-form__input is-select" name="cidade" formControlName="cidade" maxlength="30">
            <option [ngValue]="''" selected>Selecionar</option>
            <option *ngFor="let cidade of cidades" [ngValue]="cidade.nome.toUpperCase()">{{cidade.nome}}</option>
          </select>
          <app-mensagem-erro-input *ngIf="form.get('cidade')?.invalid && form.get('cidade')?.touched">Cidade é
            obrigatório.</app-mensagem-erro-input>
        </label>
      </div>
      <label for="bairro" class="c-form__label">
        Bairro *
        <input class="c-form__input" name="bairro" formControlName="bairro" maxlength="30" />
        <app-mensagem-erro-input *ngIf="form.get('bairro')?.invalid && form.get('bairro')?.touched">Bairro é
          obrigatório.</app-mensagem-erro-input>
      </label>
      <label for="complemento" class="c-form__label">
        Complemento
        <input class="c-form__input" name="complemento" formControlName="complemento" maxlength="20" />
        <app-mensagem-erro-input
          *ngIf="form.get('complemento')?.errors?.maxLength && form.get('complemento')?.touched">Complemento deve ter no
          máximo 20 caracteres.</app-mensagem-erro-input>
      </label>
    </fieldset>
    <fieldset>
      <legend class="is-title">Pedido</legend>
      <ng-container *ngIf="token.tipoUsuario === 'INT'">
        <label for="nome" class="c-form__label">
          Nome *
          <input class="c-form__input" name="nome" formControlName="nome" />
          <app-mensagem-erro-input *ngIf="form.get('nome')?.invalid && form.get('nome')?.touched">Nome é
            obrigatório.</app-mensagem-erro-input>
        </label>
        <label for="email" class="c-form__label">
          Email *
          <input class="c-form__input" name="email" formControlName="email" maxlength="200" />
          <app-mensagem-erro-input *ngIf="form.get('email')?.invalid">Email em
            formato inválido.</app-mensagem-erro-input>
          <app-mensagem-erro-input *ngIf="form.get('email')?.invalid">Email é
            obrigatório.</app-mensagem-erro-input>
        </label>
      </ng-container>
      <label for="telefone" class="c-form__label">
        Telefone
        <input class="c-form__input" name="telefone" formControlName="telefone" mask="(00) 0000-0000" />
        <app-mensagem-erro-input *ngIf="form.errors?.aoMenosUmPreenchido && form.get('telefone')?.touched">Ao menos um
          número para contato deve ser informado.</app-mensagem-erro-input>
        <app-mensagem-erro-input *ngIf="form.get('telefone')?.errors?.mask && form.get('telefone')?.touched">Telefone
          inválido.</app-mensagem-erro-input>
      </label>
      <label for="celular" class="c-form__label">
        <div class="div-message">
          Celular<p class="message">(Ao menos um número para contato deve ser informado.)</p>
        </div>
        <input class="c-form__input" name="celular" formControlName="celular" mask="(00) 0000-00000" />
        <app-mensagem-erro-input *ngIf="form.errors?.aoMenosUmPreenchido && form.get('celular')?.touched">Ao menos um
          número para contato deve ser informado.</app-mensagem-erro-input>
        <app-mensagem-erro-input *ngIf="form.get('celular')?.errors?.mask && form.get('celular')?.touched">Celular
          inválido.</app-mensagem-erro-input>
      </label>
      <label for="telefoneAlternativo" class="c-form__label">
        Telefone alternativo
        <input class="c-form__input" name="telefoneAlternativo" formControlName="telefoneAlternativo"
          mask="(00) 0000-00009" />
        <app-mensagem-erro-input *ngIf="form.errors?.aoMenosUmPreenchido && form.get('telefoneAlternativo')?.touched">Ao
          menos um número para contato deve ser informado.</app-mensagem-erro-input>
        <app-mensagem-erro-input
          *ngIf="form.get('telefoneAlternativo')?.errors?.mask && form.get('telefoneAlternativo')?.touched">Telefone
          inválido.</app-mensagem-erro-input>
      </label>
      <label class="c-form__label" for="obs">
        Observações
        <textarea class="c-form__input is-textarea" name="obs" formControlName="obs"></textarea>
        <app-mensagem-erro-input *ngIf="form.get('obs')?.errors?.maxLength && form.get('obs')?.touched">Observação deve
          ter no
          máximo 3000 caracteres.</app-mensagem-erro-input>
      </label>
    </fieldset>
    <section class="c-form__section">
      <table class="c-form__table">
        <thead class="c-form__thead">
          <tr class="c-form__thead__tr">
            <th class="c-form__thead__tr__th">Marca</th>
            <th class="c-form__thead__tr__th">Equipamentos compatíveis</th>
            <th class="c-form__thead__tr__th">Autonomia 5% A/C</th>
            <th class="c-form__thead__tr__th">Tipo</th>
            <th class="c-form__thead__tr__th">Descrição</th>
            <th class="c-form__thead__tr__th">Quantidade em estoque</th>
            <!--<th class="c-form__thead__tr__th">Quantidade em estoque</th>-->
            <th class="c-form__thead__tr__th">Vazios (devolução)</th>
          </tr>
        </thead>
        <tbody class="c-form__tbody">
          <ng-container formArrayName="produtos">
            <tr *ngFor="let produto of produtos.controls" [formGroup]="$any(produto)">
              <td class="c-form__tbody__tr__td">
                {{produto.get('nomeMarcaProdutoSuprimento')?.value}}
              </td>
              <td class="c-form__tbody__tr__td">
                <app-listagem-equipamentos-suprimentos [codContrato]="form.get('codContrato')?.value"
                  [codProduto]="produto.get('codProdutoSuprimento')?.value">
                </app-listagem-equipamentos-suprimentos>
              </td>
              <td class="c-form__tbody__tr__td">{{produto.get('autonomiaSuprimento')?.value}}</td>
              <td class="c-form__tbody__tr__td">{{produto.get('tipoSuprimento')?.value}}</td>
              <td class="c-form__tbody__tr__td">{{produto.get('nomeProdutoSuprimento')?.value}}</td>
              <td class="c-form__tbody__tr__td">
                <label for="quantidade" class="c-form__tbody__form">
                  <input name="quantidade" class="is-table-input"
                    [ngClass]="(produto.get('quantidade')?.invalid || form.errors?.obrigatorioItens) && form.get('produtos')?.touched ? 'form-control is-invalid' : 'c-form__input'"
                    type="text" name="quantidade" formControlName="quantidade" mask="0*">
                </label>
              </td>
              <!--<td class="c-form__tbody__tr__td">
                <label for="estoque" class="c-form__tbody__form">
                  <input name="estoque" class="is-table-input"
                    [ngClass]="produto.get('estoque')?.invalid && produto.get('estoque')?.touched ? 'form-control is-invalid' : 'c-form__input'"
                    type="text" name="estoque" formControlName="estoque" mask="0*">
                </label>
              </td>-->
              <td class="c-form__tbody__tr__td">
                <label for="vazios" class="c-form__tbody__form">
                  <input name="vazios" class="is-table-input"
                    [ngClass]="produto.get('vazios')?.invalid && produto.get('vazios')?.touched ? 'form-control is-invalid' : 'c-form__input'"
                    type="text" name="vazios" formControlName="vazios" mask="0*">
                </label>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <app-mensagem-erro-input *ngIf="form.errors?.obrigatorioItens && form.get('produtos')?.touched">Ao menos um
        suprimento deve ser solicitado.</app-mensagem-erro-input>
    </section>
    <app-botao-submit class="c-form__submit" [disabled]="form.invalid"
      (click)="prosseguir()">Solicitar</app-botao-submit>
  </ng-container>

  <script>
    alert('dsadsdsa');
    abrirModal();
  </script>
</form>